
import { Observable } from '../../Observable';
import { materialize } from '../../operator/materialize';

Observable.prototype.materialize = materialize;

declare module '../../Observable' {
  interface Observable<T> {
    materialize: typeof materialize;
  }
}


// WEBPACK FOOTER //
// ../../../src/add/operator/materialize.ts